import actionTypes from './actionTypes';
import api from 'src/utils/api';
import * as log from 'loglevel';

export const updateNotificationPreference = (notificationType, enabled) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.UPDATE_NOTIFICATION_PREFERENCE });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;

      // Note: we have to call the api with the specific userNotificationPreferenceId
      // to be able to update the preferences so we need to fetch them first
      // TODO: update the api to accept the notificationType or notificationId
      const response = await api.auroraGet('user-notification-preference', {
        params: { userId: currentUser.userId },
      });

      const {
        data: {
          payload: {
            userNotificationPreference: { notificationPreference: currentPreferences },
          },
        },
      } = response;

      const currentPreference = currentPreferences.find(x => x.notificationType === notificationType);
      if (!currentPreference) return;

      const updatedPreference = { ...currentPreference, enabled };
      await api.auroraPut('user-notification-preference', {
        userId: currentUser.userId,
        notificationPreference: [updatedPreference],
      });

      return dispatch({
        type: actionTypes.UPDATE_NOTIFICATION_PREFERENCE_SUCCESS,
      });
    } catch (ex) {
      log.error(ex);
      return dispatch({ type: actionTypes.UPDATE_NOTIFICATION_PREFERENCE_FAILURE, error: ex });
    }
  };
};
